import type { ComplianceAlert, MuteDuration } from '@/services/api/compliance-alerts';
import { uniqueSorted } from '@/utils/array';
import { formatSnakeCase, pluralize } from '@/utils/string';

export interface DismissSelectionSummary {
  alertCount: number;
  pids: string[];
  eventTypes: string[];
}

export const summariseDismissSelection = (alerts: ComplianceAlert[]): DismissSelectionSummary => ({
  alertCount: alerts.length,
  pids: uniqueSorted(alerts.map((alert) => alert.pid)),
  eventTypes: uniqueSorted(alerts.map((alert) => formatSnakeCase(alert.event_type))),
});

export const describeDismissSelection = ({ alertCount, pids, eventTypes }: DismissSelectionSummary): string =>
  `${pluralize(alertCount, 'alert')} (${eventTypes.join(', ')}) ${pids.length === 1 ? 'for' : 'across'} ${pluralize(pids.length, 'user')}`;

export const describeDismissal = (subject: string, muteDuration?: MuteDuration): string =>
  `Proceeding with this action will dismiss ${subject}${muteDuration ? ` and mute similar alerts for ${muteDuration}` : ''}. Your action here will be logged and will be auditable.`;
